import { render } from "./SellerAutocomplete.vue?vue&type=template&id=03a3306d&scoped=true"
import script from "./SellerAutocomplete.vue?vue&type=script&lang=ts"
export * from "./SellerAutocomplete.vue?vue&type=script&lang=ts"

import "./SellerAutocomplete.vue?vue&type=style&index=0&id=03a3306d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03a3306d"

export default script